// @flow

export default class Event {
  static getDurationFromSec(durationInSec: ?(number | string)): string {
    const normDuration =
      typeof durationInSec !== 'number' ? parseInt(durationInSec, 10) : durationInSec;

    if (!normDuration) return '—';

    const hours = Math.floor(normDuration / 60 / 60);
    const minutes = normDuration / 60 - hours * 60;

    return `${hours ? `${hours}h ` : ''}${minutes ? `${minutes}m ` : ''}`;
  }

  static getDurationFromStr(durationInSec: ?string): string {
    if (!durationInSec) return '—';

    const [hours, minutesPercents] = durationInSec.toString().split('.');

    const minutes = Math.floor(0.6 * parseInt(minutesPercents, 10));

    return `${hours ? `${hours}h ` : ''}${minutes ? `${minutes}m ` : ''}`;
  }
}
